import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { styles } from "./styles";

class LinkExpired extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={"box box-default " + classes.link_expired_card}>
        <div className={"box-body text-center " + classes.link_expired_body}>
          <h2 className={classes.link_expired_title}>
            <span className={classes.link_expired_title_text}>
              Link Expired
              <span className={"material-icons " + classes.link_expired_icon}>
                link_off
              </span>
            </span>
          </h2>
          <p className={classes.link_expired_text}>
            This approval link is no longer valid.
          </p>
        </div>
      </div>
    );
  }
}

LinkExpired.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LinkExpired);
